import { createLogger } from "@/domain/logging";

export const generatorLog = createLogger("GENERATE");
